$(function () {
    const header = document.querySelector('.page-header');
    const menuToggle = document.querySelector('.js-menu-toggle');
    const menuClose = document.querySelector('.js-menu-close');
    const mobileMenu = document.querySelector('.js-mobile-menu');
    const body = document.body;

    let lastScrollTop = 0;

    function stickyHeader() {
        if (!header || body.classList.contains('menu-open')) return;

        const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

        if (currentScroll <= 0) {
            header.classList.remove('sticky');
        } else if (currentScroll < lastScrollTop) {
            header.classList.add('sticky');
        } else {
            header.classList.remove('sticky');
        }

        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    }

    function openMenu() {
        if (!mobileMenu || !menuToggle) return;

        mobileMenu.classList.add('is-open');
        body.classList.add('menu-open');
        header.classList.remove('sticky');

        menuToggle.setAttribute('aria-expanded', 'true');
        mobileMenu.setAttribute('aria-hidden', 'false');
    }

    function closeMenu() {
        if (!mobileMenu || !menuToggle) return;

        mobileMenu.classList.remove('is-open');
        body.classList.remove('menu-open');

        menuToggle.setAttribute('aria-expanded', 'false');
        mobileMenu.setAttribute('aria-hidden', 'true');
    }

    function buildMobileSubmenus() {
        if (!mobileMenu) return;

        const menuItems = mobileMenu.querySelectorAll('.menu-item-has-children');

        menuItems.forEach((item, index) => {
            const link = item.querySelector(':scope > a');
            const subMenu = item.querySelector(':scope > .sub-menu');

            if (!link || !subMenu) return;
            if (item.querySelector(':scope > .submenu-toggle-wrap')) return;

            const wrap = document.createElement('div');
            wrap.className = 'submenu-toggle-wrap';

            const toggle = document.createElement('button');
            toggle.className = 'submenu-toggle';
            toggle.type = 'button';
            toggle.setAttribute('aria-expanded', 'false');

            const submenuId = `mobile-submenu-${index + 1}`;
            subMenu.id = submenuId;
            toggle.setAttribute('aria-controls', submenuId);
            toggle.setAttribute('aria-label', 'Toggle submenu');

            link.parentNode.insertBefore(wrap, link);
            wrap.appendChild(link);
            wrap.appendChild(toggle);

            toggle.addEventListener('click', function (e) {
                e.preventDefault();

                const isOpen = item.classList.contains('is-open');

                item.classList.toggle('is-open', !isOpen);
                toggle.setAttribute('aria-expanded', String(!isOpen));

                $(subMenu).stop(true, true).slideToggle(250);
            });
        });
    }

    if (menuToggle) {
        menuToggle.addEventListener('click', openMenu);
    }

    if (menuClose) {
        menuClose.addEventListener('click', closeMenu);
    }

    if (mobileMenu) {
        mobileMenu.addEventListener('click', function (e) {
            if (e.target === mobileMenu) {
                closeMenu();
            }
        });

        const mobileLinks = mobileMenu.querySelectorAll('a');

        mobileLinks.forEach((link) => {
            link.addEventListener('click', function () {
                const parentItem = link.closest('.menu-item-has-children');

                if (window.innerWidth <= 1024 && !parentItem) {
                    closeMenu();
                }
            });
        });
    }

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('is-open')) {
            closeMenu();
        }
    });

    window.addEventListener('scroll', stickyHeader);
    window.addEventListener('resize', function () {
        if (window.innerWidth > 1024) {
            closeMenu();
        }
    });

    buildMobileSubmenus();
    stickyHeader();
});